import React, { useState } from 'react';
import { apiService } from '../services/api';
import { useApi, useMutation } from '../hooks/useApi';
import logger from '../utils/logger';
import { MapPin, Pencil, Trash2, PlusCircle } from 'lucide-react';

function Lokacionet() {
  const [form, setForm] = useState({ emri: '', adresa: '', menaxher_id: '' });
  const [editId, setEditId] = useState(null);

  const { data: lokacionetData, execute: refetchLokacionet } = useApi(
    () => apiService.get('/lokacionet'),
    [],
    { immediate: true, showNotifications: false }
  );

  const { data: menaxheretData } = useApi(
    () => apiService.get('/perdoruesit', { params: { roli: 'menaxher' } }),
    [],
    { immediate: true, showNotifications: false }
  );

  const lokacionet = Array.isArray(lokacionetData) ? lokacionetData : (lokacionetData?.data || []);
  const menaxheret = Array.isArray(menaxheretData) ? menaxheretData : (menaxheretData?.data || []);

  const { mutate: saveLokacion, loading: saving } = useMutation(
    async (data) => {
      if (editId) {
        return await apiService.put(`/lokacionet/${editId}`, data);
      } else {
        return await apiService.post('/lokacionet', data);
      }
    },
    {
      successMessage: editId ? 'Lokacioni u përditësua me sukses!' : 'Lokacioni u shtua me sukses!',
      onSuccess: () => {
        setForm({ emri: '', adresa: '', menaxher_id: '' });
        setEditId(null);
        refetchLokacionet();
      }
    }
  );

  const { mutate: deleteLokacion } = useMutation(
    async (id) => {
      return await apiService.delete(`/lokacionet/${id}`);
    },
    {
      successMessage: 'Lokacioni u fshi me sukses!',
      onSuccess: () => {
        refetchLokacionet();
      }
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    saveLokacion(form);
  };

  const handleEdit = (lok) => {
    setEditId(lok.id);
    setForm({
      emri: lok.emri || '',
      adresa: lok.adresa || '',
      menaxher_id: lok.menaxher_id || ''
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('A dëshironi të fshini këtë lokacion?')) return;
    deleteLokacion(id);
  };

  return (
    <div className="w-full animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          <MapPin size={32} className="text-primary-600 dark:text-primary-400" />
        </div>
        Menaxhimi i Lokacioneve
      </h2>

      <form onSubmit={handleSubmit} className="card-premium p-6 mb-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <input
          type="text"
          placeholder="Emri i Lokacionit"
          className="input-premium"
          value={form.emri}
          onChange={(e) => setForm({ ...form, emri: e.target.value })}
          required
        />
        <input
          type="text"
          placeholder="Adresa"
          className="input-premium"
          value={form.adresa}
          onChange={(e) => setForm({ ...form, adresa: e.target.value })}
        />
        <select
          value={form.menaxher_id}
          onChange={(e) => setForm({ ...form, menaxher_id: e.target.value })}
          className="input-premium"
        >
          <option value="">Zgjidh Menaxherin</option>
          {menaxheret.map((m) => (
            <option key={m.id} value={m.id}>{m.emri}</option>
          ))}
        </select>

        <button
          type="submit"
          disabled={saving}
          className="col-span-full btn-primary flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <PlusCircle size={20} />
          {saving ? 'Po ruhet...' : (editId ? 'Përditëso' : 'Shto Lokacion')}
        </button>
      </form>

      <div className="card-premium overflow-hidden">
        <table className="table-premium">
          <thead>
            <tr>
              <th>Emri</th>
              <th>Adresa</th>
              <th>Menaxheri</th>
              <th>Veprime</th>
            </tr>
          </thead>
          <tbody>
            {lokacionet.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center py-8 text-gray-500 dark:text-gray-400">
                  Nuk ka lokacione të regjistruar
                </td>
              </tr>
            ) : (
              lokacionet.map((l) => (
                <tr key={l.id}>
                  <td className="font-medium">{l.emri}</td>
                  <td>{l.adresa || '-'}</td>
                  <td>{l.menaxher?.emri || '-'}</td>
                  <td>
                    <div className="flex flex-wrap gap-2">
                      <button
                        onClick={() => handleEdit(l)}
                        className="text-secondary-600 dark:text-secondary-400 hover:text-secondary-800 dark:hover:text-secondary-300 inline-flex items-center gap-1 transition-colors"
                      >
                        <Pencil size={16} /> Edito
                      </button>
                      <button
                        onClick={() => handleDelete(l.id)}
                        className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 inline-flex items-center gap-1 transition-colors"
                      >
                        <Trash2 size={16} /> Fshi
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Lokacionet;
